import attractionData from './attraction-data';
import festivalData from './festival-data';
import natureAreas from './nature-areas';

function featureToOption(feature) {
  const { properties, geometry } = feature;
  const isCity = properties.category === 'city';

  return {
    label: properties.name || properties.municipality,
    sublabel: isCity
      ? (properties.province || null)
      : (properties.province || properties.municipality),
    value: properties.id || properties.name,
    coordinates: geometry.coordinates,
  };
}

const questionOptions = {
  question3: attractionData.features
    .filter(feature => feature.properties.category === 'city')
    .map(featureToOption)
    .sort((left, right) => left.label.localeCompare(right.label, 'nl-BE')),
  question4: festivalData.features.map(featureToOption),
  question5: natureAreas.map(area => ({
    label: area.name,
    sublabel: area.province,
    value: `nature:${area.name}`,
    coordinates: area.coordinates,
  })),
};

export default questionOptions;
